import(/* webpackMode: "eager" */ "/workspace/node_modules/.pnpm/next@15.2.4_@babel+core@7.26.10_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Woobox"] */ "/workspace/src/components/blocks/Woobox.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GTMDataLayer"] */ "/workspace/src/components/GTMDataLayer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["KlaviyoModal"] */ "/workspace/src/components/KlaviyoModal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScheduleList"] */ "/workspace/src/components/templates/Schedule/ScheduleList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TicketPackageButton"] */ "/workspace/src/components/TicketPackageButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Accordion","AccordionItem","AccordionTrigger","AccordionContent"] */ "/workspace/src/components/ui/accordion.tsx");
